import { render, staticRenderFns } from "./DeleteMarketGoodsItem.vue?vue&type=template&id=7299d2d1&scoped=true"
import script from "./DeleteMarketGoodsItem.vue?vue&type=script&lang=js"
export * from "./DeleteMarketGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./DeleteMarketGoodsItem.vue?vue&type=style&index=0&id=7299d2d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7299d2d1",
  null
  
)

export default component.exports